import type { ReactNode } from "react";
import { Button } from "@design-lab/shared/ui/design-system/Button";

type PinningActionBarProps = {
  onCancel: () => void;
  onDone: () => void;
  onDoneDisabledClick?: () => void;
  isCancelDisabled: boolean;
  isDoneDisabled: boolean;
  isLoading: boolean;
  variant?: "absolute" | "static";
  leftContent?: ReactNode;
};

export function PinningActionBar({
  onCancel,
  onDone,
  onDoneDisabledClick,
  isCancelDisabled,
  isDoneDisabled,
  isLoading,
  variant = "absolute",
  leftContent
}: PinningActionBarProps) {
  const hasLeftContent = leftContent != null;
  const className =
    variant === "absolute"
      ? `absolute bottom-0 left-0 right-0 z-10 flex items-center ${hasLeftContent ? "justify-between" : "justify-end"} rounded-b-xl bg-white p-2 shadow-[0_-2px_10px_rgba(0,0,0,0.05)]`
      : `flex shrink-0 items-center ${hasLeftContent ? "justify-between" : "justify-end"} bg-white p-2 shadow-[0_-2px_10px_rgba(0,0,0,0.05)]`;

  return (
    <div className={className} data-testid="pinning-artboard-actions">
      {leftContent && <div className="flex items-center">{leftContent}</div>}
      <div className="flex items-center">
        <Button
          variant="link"
          className="text-blue-700 no-underline hover:text-blue-800 hover:no-underline"
          onPress={onCancel}
          data-testid="pinning-cancel"
          isDisabled={isCancelDisabled}
        >
          Cancel
        </Button>
        <div className="relative inline-flex">
          <Button
            className="bg-blue-700 text-white hover:bg-blue-800 disabled:opacity-50"
            onPress={onDone}
            data-testid="pinning-done"
            isDisabled={isDoneDisabled}
          >
            {isLoading ? "Completing..." : "Done"}
          </Button>
          {isDoneDisabled && onDoneDisabledClick && (
            <button
              type="button"
              onClick={onDoneDisabledClick}
              className="absolute inset-0 z-10 h-full w-full cursor-pointer opacity-0"
              aria-label="Button is disabled because of an unfinished pin"
              data-testid="pinning-done-disabled-overlay"
            />
          )}
        </div>
      </div>
    </div>
  );
}
